import { render, staticRenderFns } from "./WatsonActiveIntents.vue?vue&type=template&id=dd79a6bc&scoped=true&"
import script from "./WatsonActiveIntents.vue?vue&type=script&lang=js&"
export * from "./WatsonActiveIntents.vue?vue&type=script&lang=js&"
import style0 from "./WatsonActiveIntents.vue?vue&type=style&index=0&id=dd79a6bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd79a6bc",
  null
  
)

export default component.exports